import { Stack } from "@mui/material";
import { Alert } from "klayowebshared";
import React, { Component } from "react";
import { AppContext } from "../../common/AppContext";
import { Dialog } from "../../components/dialogs/Dialog";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";

interface ConfirmDeleteTaskDialogProps extends WithLocaleProps {
  theme?: any;
  title?: string;
  content?: React.ReactNode;
  error?: string;
  onClose?: () => void;
  onConfirm?: () => void;
  onNotConfirm?: () => void;
}

class ConfirmDeleteTaskDialogBase extends Component<ConfirmDeleteTaskDialogProps> {
  static contextType = AppContext;

  render() {
    const { theme, onClose, error, title, content, onConfirm, onNotConfirm, translate } =
      this.props;

    return (
      <Dialog
        open={true}
        theme={theme}
        onClose={onClose}
        fullWidth={true}
        maxWidth='sm'
        title={title}
        actions={[
          {
            label: translate("common.cancel"),
            onClick: onClose
          },
          {
            label: translate("common.no"),
            acceptWarning: true,
            onClick: onNotConfirm
          },
          {
            label: translate("common.yes"),
            primary: true,
            onClick: onConfirm
          }
        ]}
      >
        <Stack direction='column' spacing={4}>
          {error && (
            <Alert severity='error' sx={{ width: "100%" }}>
              {error}
            </Alert>
          )}
          {content}
        </Stack>
      </Dialog>
    );
  }
}

export const ConfirmDeleteTaskDialog = withLocale(ConfirmDeleteTaskDialogBase);
